export const engagementAppGroupIdFeatureFlagsInfo = "/engagement/:app_group_id/feature_flags_info";
